export const INTENTS = ["bill", "learn", "other"] as const;

export type Intent = (typeof INTENTS)[number];

export const isIntent = (value: string): value is Intent =>
  (INTENTS as readonly string[]).includes(value);

export type IntentData = { intent: Intent };

/**
 * Post-auth shape: `intent` is required but may be `undefined` when the user
 * reaches the post-auth segment without a stashed intent. Callers must pass
 * `intent: undefined` explicitly so the absence is a deliberate signal.
 */
export type ResolvedIntentData = { intent: Intent | undefined };
